import { ActionInfo } from "./ActionInfoTypes";

// Buy Alpha Team Cruiser (6772-1)
export const BuySet_AlphaTeamCruiser: ActionInfo = {
  id: "buy_set_6772-1",
  type: "BuySet",
  title: "Alpha Team Cruiser",
  details: "Purchase the Alpha Team Cruiser set",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 75,
      type: "brick",
    },
    {
      brickId: "3004",
      baseChangeValue: 75,
      type: "brick",
    },
    {
      brickId: "3024",
      baseChangeValue: 75,
      type: "brick",
    },
    {
      brickId: "3023",
      baseChangeValue: 75,
      type: "brick",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "6772-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [
    {
      actionId: "brickpack_animals_part_one",
    },
    {
      actionId: "brickpack_minifig_utensils_part_two",
    },
    {
      actionId: "brickpack_bionicles_part_two",
    },
    {
      actionId: "brickpack_circular_bricks",
    },
    {
      actionId: "brickpack_minifig_hair",
    },
    {
      actionId: "brickpack_technic_bricks",
    },
    {
      actionId: "brickpack_minifig_headgear",
    },
  ],
  isBrickpack: false,
};

// Buy Tahu (8534-1)
export const BuySet_Tahu: ActionInfo = {
  id: "buy_set_8534-1",
  type: "BuySet",
  title: "Tahu",
  details: "Purchase the Tahu set",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 150,
      type: "brick",
    },
    {
      brickId: "3003",
      baseChangeValue: 150,
      type: "brick",
    },
    {
      brickId: "4349",
      baseChangeValue: 35,
      type: "brick",
    },
    {
      brickId: "30228",
      baseChangeValue: 35,
      type: "brick",
    },
    {
      brickId: "4449",
      baseChangeValue: 35,
      type: "brick",
    },
    {
      brickId: "3962a",
      baseChangeValue: 35,
      type: "brick",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "8534-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

// Buy The Knight Bus (4866-1)
export const BuySet_TheKnightBus: ActionInfo = {
  id: "buy_set_4866-1",
  type: "BuySet",
  title: "The Knight Bus",
  details: "Purchase The Knight Bus set",
  cost: [
    {
      brickId: "3710",
      baseChangeValue: 150,
      type: "brick",
    },
    {
      brickId: "3022",
      baseChangeValue: 150,
      type: "brick",
    },
    {
      brickId: "6091",
      baseChangeValue: 35,
      type: "brick",
    },
    {
      brickId: "6246a",
      baseChangeValue: 35,
      type: "brick",
    },
    {
      brickId: "3835",
      baseChangeValue: 35,
      type: "brick",
    },
    {
      brickId: "93106",
      baseChangeValue: 35,
      type: "brick",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "4866-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

// Buy Garbage Truck (4432-1)
export const BuySet_GarbageTruck: ActionInfo = {
  id: "buy_set_4432-1",
  type: "BuySet",
  title: "Garbage Truck",
  details: "Purchase the Garbage Truck set",
  cost: [
    {
      brickId: "60477",
      baseChangeValue: 250,
      type: "brick",
    },
    {
      brickId: "30148",
      baseChangeValue: 100,
      type: "brick",
    },
    {
      brickId: "54271",
      baseChangeValue: 40,
      type: "brick",
    },
    {
      brickId: "47298",
      baseChangeValue: 40,
      type: "brick",
    },
    {
      brickId: "80674",
      baseChangeValue: 25,
      type: "brick",
    },
    {
      brickId: "92084",
      baseChangeValue: 25,
      type: "brick",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "4432-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

// Buy TIE Fighter (7146-1)
export const BuySet_TIEFighter: ActionInfo = {
  id: "buy_set_7146-1",
  type: "BuySet",
  title: "TIE Fighter",
  details: "Purchase the TIE Fighter set",
  cost: [
    {
      brickId: "6772-1",
      baseChangeValue: 40,
      type: "set",
    },
    {
      brickId: "8534-1",
      baseChangeValue: 40,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 30,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "7146-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

// Buy Lloyd's Legendary Dragon (71766-1)
export const BuySet_LloydsLegendaryDragon: ActionInfo = {
  id: "buy_set_71766-1",
  type: "BuySet",
  title: "Lloyd's Legendary Dragon",
  details: "Purchase Lloyd's Legendary Dragon set",
  cost: [
    {
      brickId: "32574",
      baseChangeValue: 30,
      type: "brick",
    },
    {
      brickId: "32573",
      baseChangeValue: 30,
      type: "brick",
    },
    {
      brickId: "32568",
      baseChangeValue: 30,
      type: "brick",
    },
    {
      brickId: "6222",
      baseChangeValue: 15,
      type: "brick",
    },
    {
      brickId: "6014b",
      baseChangeValue: 15,
      type: "brick",
    },
    {
      brickId: "50990b",
      baseChangeValue: 15,
      type: "brick",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "71766-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [
    { actionId: "auto_collect_3005_75" },
    { actionId: "auto_collect_3004_75" },
    { actionId: "auto_collect_3024_75" },
    { actionId: "auto_collect_3023_75" },
    { actionId: "auto_collect_3010_75" },
    { actionId: "auto_collect_3003_75" },
    { actionId: "auto_collect_3001_75" },
    { actionId: "auto_collect_3710_75" },
    { actionId: "auto_collect_3022_75" },
    { actionId: "auto_collect_3020_75" },
    { actionId: "increase_capacity_3005_350" },
    { actionId: "increase_capacity_3004_350" },
    { actionId: "increase_capacity_3024_350" },
    { actionId: "increase_capacity_3023_350" },
    { actionId: "increase_capacity_3010_350" },
    { actionId: "increase_capacity_3003_350" },
    { actionId: "increase_capacity_3001_350" },
    { actionId: "increase_capacity_3710_350" },
    { actionId: "increase_capacity_3022_350" },
    { actionId: "increase_capacity_3020_350" },
    { actionId: "auto_collect_brickpack_sloped_bricks_part_one_75" },
    { actionId: "auto_collect_brickpack_minifig_utensils_part_one_75" },
    { actionId: "auto_collect_brickpack_bionicles_part_one_75" },
  ],
  isBrickpack: false,
};

// Buy Himeji Castle (21060-1)
export const BuySet_HimejiCastle: ActionInfo = {
  id: "buy_set_21060-1",
  type: "BuySet",
  title: "Himeji Castle",
  details: "Purchase the Himeji Castle set",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 2500,
      type: "brick",
    },
    {
      brickId: "3004",
      baseChangeValue: 2500,
      type: "brick",
    },
    {
      brickId: "3962a",
      baseChangeValue: 2500,
      type: "brick",
    },
    {
      brickId: "32553",
      baseChangeValue: 1500,
      type: "brick",
    },
    {
      brickId: "x346",
      baseChangeValue: 1500,
      type: "brick",
    },
    {
      brickId: "64644",
      baseChangeValue: 50,
      type: "brick",
    },
    {
      brickId: "41531",
      baseChangeValue: 30,
      type: "brick",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "21060-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

// Buy Lion Knights' Castle (10305-1)
export const BuySet_LionKnightsCastle: ActionInfo = {
  id: "buy_set_10305-1",
  type: "BuySet",
  title: "Lion Knights' Castle",
  details: "Purchase Lion Knights' Castle set",
  cost: [
    {
      brickId: "3024",
      baseChangeValue: 3500,
      type: "brick",
    },
    {
      brickId: "3023",
      baseChangeValue: 3500,
      type: "brick",
    },
    {
      brickId: "32574",
      baseChangeValue: 350,
      type: "brick",
    },
    {
      brickId: "32505",
      baseChangeValue: 350,
      type: "brick",
    },
    {
      brickId: "32571",
      baseChangeValue: 350,
      type: "brick",
    },

    {
      brickId: "30410",
      baseChangeValue: 25,
      type: "brick",
    },
    {
      brickId: "53982",
      baseChangeValue: 25,
      type: "brick",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "10305-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [
    { actionId: "auto_collect_3005_250" },
    { actionId: "auto_collect_3004_250" },
    { actionId: "auto_collect_3024_250" },
    { actionId: "auto_collect_3023_250" },
    { actionId: "auto_collect_3010_250" },
    { actionId: "auto_collect_3003_250" },
    { actionId: "auto_collect_3001_250" },
    { actionId: "auto_collect_3710_250" },
    { actionId: "auto_collect_3022_250" },
    { actionId: "auto_collect_3020_250" },
    { actionId: "increase_capacity_3005_1000" },
    { actionId: "increase_capacity_3004_1000" },
    { actionId: "increase_capacity_3024_1000" },
    { actionId: "increase_capacity_3023_1000" },
    { actionId: "increase_capacity_3010_1000" },
    { actionId: "increase_capacity_3003_1000" },
    { actionId: "increase_capacity_3001_1000" },
    { actionId: "increase_capacity_3710_1000" },
    { actionId: "increase_capacity_3022_1000" },
    { actionId: "increase_capacity_3020_1000" },
  ],
  isBrickpack: false,
};

// Buy Millennium Falcon (10179-1)
export const BuySet_MillenniumFalcon: ActionInfo = {
  id: "buy_set_10179-1",
  type: "BuySet",
  title: "Millennium Falcon",
  details: "Purchase the Millennium Falcon set",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3004",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3010",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3003",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3001",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3020",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3024",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3023",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3710",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3022",
      baseChangeValue: 12000,
      type: "brick",
    },
    {
      brickId: "3962a",
      baseChangeValue: 3000,
      type: "brick",
    },
    {
      brickId: "30162",
      baseChangeValue: 3000,
      type: "brick",
    },
    {
      brickId: "6086",
      baseChangeValue: 250,
      type: "brick",
    },
    {
      brickId: "6222",
      baseChangeValue: 250,
      type: "brick",
    },
    {
      brickId: "3901",
      baseChangeValue: 250,
      type: "brick",
    },
    {
      brickId: "3736",
      baseChangeValue: 50,
      type: "brick",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "10179-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

// Buy Eiffel Tower (10307-1)
export const BuySet_EiffelTower: ActionInfo = {
  id: "buy_set_10307-1",
  type: "BuySet",
  title: "Eiffel Tower",
  details: "Purchase the Eiffel Tower set",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 15000,
      type: "brick",
    },
    {
      brickId: "6246f",
      baseChangeValue: 50,
      type: "brick",
    },
    {
      brickId: "32566",
      baseChangeValue: 50,
      type: "brick",
    },
    {
      brickId: "4285b",
      baseChangeValue: 50,
      type: "brick",
    },
    {
      brickId: "37784",
      baseChangeValue: 50,
      type: "brick",
    },
    {
      brickId: "32168",
      baseChangeValue: 50,
      type: "brick",
    },
    {
      brickId: "7146-1",
      baseChangeValue: 50,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 40,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 30,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 30,
      type: "set",
    },
    {
      brickId: "10179-1",
      baseChangeValue: 20,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "10307-1", // Set ID
      baseChangeValue: 1,
      type: "set",
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};
